<div class="cf" [class.cf--terminal]="terminal">
    <!-- The server's own message: in A2 and C2 the anchored field is
         counter-intuitive, so this is the explanation, not our copy. -->
    <div class="cf__head">
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path
                d="M7.5 1.25a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5Zm0 11.25a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm0-5.31a.63.63 0 0 0-.63.62v1.88a.63.63 0 1 0 1.26 0V7.81a.63.63 0 0 0-.63-.62Zm0-2.5a.81.81 0 1 0 0 1.62.81.81 0 0 0 0-1.62Z"
                fill="currentColor" />
        </svg>
        <span>{{ conflict?.message }}</span>
    </div>

    <!-- Terminal: show whoever already holds the student, offer nothing -->
    <ng-container *ngIf="terminal">
        <div class="cf__parents">
            <div class="cf-parent" *ngFor="let p of terminalParents; trackBy: trackByIndex">
                <!-- labelled rows, stacked, exactly as the candidate cards read -->
                <div class="cf-row" *ngFor="let key of parentRows; trackBy: trackByIndex">
                    <span class="cf-row__label">{{ ('student-conflicts.fields.' + key) | translate }}</span>
                    <span class="cf-row__value" [class.cf-row__value--ltr]="isPhone(key)">
                        {{ guardianValue(p, key) }}
                    </span>
                </div>
            </div>
        </div>
        <p class="cf__note">{{ terminalHintKey | translate }}</p>
    </ng-container>

    <!-- Everything else: the two candidates, exactly as the bulk detail panel -->
    <ng-container *ngIf="!terminal">
        <div class="cf__cands">
            <div class="cf-card">
                <span class="cf-card__src">{{ 'student-conflicts.existing-value' | translate }}</span>

                <ng-container *ngIf="isSchool">
                    <div class="cf-row cf-row--affected">
                        <span class="cf-row__label">{{ 'student-conflicts.school' | translate }}</span>
                        <span class="cf-row__value">{{ schoolName('existing') }}</span>
                    </div>
                </ng-container>

                <ng-container *ngIf="!isSchool">
                    <div class="cf-row" *ngFor="let key of rows; trackBy: trackByIndex"
                        [class.cf-row--affected]="key === affectedKey">
                        <span class="cf-row__label">{{ ('student-conflicts.fields.' + key) | translate }}</span>
                        <span class="cf-row__value" [class.cf-row__value--ltr]="isPhone(key)">
                            {{ value('existing', key) }}
                        </span>
                    </div>
                </ng-container>

                <button *ngIf="allows('existing')" type="button" class="cf-use" (click)="pick('existing')">
                    {{ 'student-conflicts.use-this' | translate }}
                </button>
                <span *ngIf="!allows('existing') && !acknowledgeOnly" class="cf-locked">
                    {{ 'student-conflicts.not-offered' | translate }}
                </span>
            </div>

            <div class="cf-card cf-card--submitted">
                <span class="cf-card__src">{{ 'student-conflicts.submitted-value' | translate }}</span>

                <ng-container *ngIf="isSchool">
                    <div class="cf-row cf-row--affected">
                        <span class="cf-row__label">{{ 'student-conflicts.school' | translate }}</span>
                        <span class="cf-row__value">{{ schoolName('submitted') }}</span>
                    </div>
                </ng-container>

                <ng-container *ngIf="!isSchool">
                    <div class="cf-row" *ngFor="let key of rows; trackBy: trackByIndex"
                        [class.cf-row--affected]="key === affectedKey">
                        <span class="cf-row__label">{{ ('student-conflicts.fields.' + key) | translate }}</span>
                        <span class="cf-row__value" [class.cf-row__value--ltr]="isPhone(key)">
                            {{ value('submitted', key) }}
                        </span>
                    </div>
                </ng-container>

                <div *ngIf="warnsAboutQr" class="cf-warn">
                    {{ 'student-conflicts.qr-warning' | translate }}
                </div>

                <button *ngIf="allows('submitted')" type="button" class="cf-use" (click)="pick('submitted')">
                    {{ 'student-conflicts.use-this' | translate }}
                </button>
                <!-- Refusing a disallowed source is a backend guard; never offer it,
                     but say why so the admin is not left guessing. -->
                <span *ngIf="!allows('submitted') && !acknowledgeOnly" class="cf-locked">
                    {{ 'student-conflicts.not-offered' | translate }}
                </span>
            </div>
        </div>

        <div *ngIf="acknowledgeOnly" class="cf__actions">
            <button type="button" class="cf-primary" (click)="pick('acknowledge')">
                {{ 'student-conflicts.acknowledge' | translate }}
            </button>
        </div>
    </ng-container>
</div>
